import theme from 'src/theme';

export const sidebarSx = {
    root: {
        width: 280,
        minWidth: 280,
        borderRight: '1px solid rgba(0, 0, 0, 0.06)',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#FAFBFD',
        height: '100%',
    },
    header: {
        px: 2,
        pt: 2.5,
        pb: 2,
    },
    newChatButton: {
        borderRadius: '12px',
        textTransform: 'none',
        fontWeight: 600,
        py: 1.25,
        fontSize: '0.84rem',
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        color: theme.palette.common.white,
        boxShadow: '0 2px 6px rgba(0, 127, 220, 0.25)',
        transition: 'all 0.2s ease',
        '&:hover': {
            background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.main})`,
            boxShadow: '0 4px 12px rgba(0, 127, 220, 0.35)',
            transform: 'translateY(-1px)',
        },
        '&:active': {
            transform: 'translateY(0)',
        },
    },
    divider: {
        mx: 2,
        borderColor: 'rgba(0, 0, 0, 0.05)',
    },
    groupLabel: {
        px: 1,
        pt: 2,
        pb: 0.75,
        fontSize: '0.68rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        color: theme.palette.neutral[400],
    },
    list: {
        flex: 1,
        overflow: 'auto',
        px: 1.5,
    },
    sessionItem: {
        borderRadius: '10px',
        px: 1.5,
        py: 1.25,
        mb: 0.5,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '& .delete-btn': {opacity: 0, transition: 'opacity 0.15s ease'},
        '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.03)',
            '& .delete-btn': {opacity: 1},
        },
    },
    sessionItemActive: {
        borderRadius: '10px',
        px: 1.5,
        py: 1.25,
        mb: 0.5,
        cursor: 'pointer',
        bgcolor: 'rgba(0, 127, 220, 0.07)',
        border: '1px solid rgba(0, 127, 220, 0.15)',
        '& .delete-btn': {opacity: 0, transition: 'opacity 0.15s ease'},
        '&:hover': {
            bgcolor: 'rgba(0, 127, 220, 0.09)',
            '& .delete-btn': {opacity: 1},
        },
    },
    sessionTitleRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 0.5,
    },
    deleteButton: {
        flexShrink: 0,
        width: 26,
        height: 26,
        color: theme.palette.neutral[400],
        transition: 'all 0.15s ease',
        '&:hover': {
            color: theme.palette.error.main,
            bgcolor: 'rgba(230, 41, 48, 0.08)',
        },
    },
    sessionTitle: {
        fontSize: '0.84rem',
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: theme.palette.text.primary,
        lineHeight: 1.4,
    },
    sessionMeta: {
        display: 'flex',
        alignItems: 'center',
        mt: 0.25,
    },
    sessionDate: {
        fontSize: '0.7rem',
        color: theme.palette.neutral[400],
    },
    emptyText: {
        px: 1.5,
        py: 3,
        fontSize: '0.82rem',
        color: theme.palette.neutral[400],
        textAlign: 'center',
    },
    sessionPreview: {
        fontSize: '0.72rem',
        color: theme.palette.neutral[500],
        mt: 0.5,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: 1.3,
    },
};
